export default __webpack_public_path__ + "static/media/bin.d6412671.svg";